import { useState } from "react";
import { wrapReactRouterRouting } from "@sentry/react";
import { Routes, Route } from "react-router";
import Layout from "./components/layout";
import Intro from "./views/intro";
import Characters from "./views/characters";
import Analysis from "./views/analysis";
import Result from "./views/result";
import Dashboard from "./views/dashboard";
import DashboardPosts from "./views/dashboard_posts";
import CHARACTERS from "./characters";

const SentryRoutes = wrapReactRouterRouting(Routes);

export default function App({ response }) {
  const [posts, setPosts] = useState([]);

  function handleStart(newGroup) {
    response.setAnswers(newGroup);
    response.save();
  }

  function handleAnswerChange(characterKey, values) {
    response.setAnswer(characterKey, values);
  }

  function handleFinish(characterKey) {
    const finished = response.getAnswer("finished") ?? [];
    if (finished.includes(characterKey)) return;

    response.setAnswer("finished", [...finished, characterKey]);
    if (finished.length + 1 === CHARACTERS.length) {
      response.setAnswer("completed", true);
    }

    response.save();
  }

  return (
    <Layout>
      <SentryRoutes>
        <Route path="/" element={<Intro onStart={handleStart} />} />
        <Route
          path="/personages"
          element={<Characters response={response} />}
        />
        <Route
          path="/analyse/:characterKey?"
          element={
            <Analysis
              response={response}
              onAnswerChange={handleAnswerChange}
              onFinish={handleFinish}
            />
          }
        />
        <Route path="/result" element={<Result response={response} />} />
        <Route path="/dashboard" element={<Dashboard setPosts={setPosts} />} />
        <Route
          path="/dashboard/:groupCode"
          element={<DashboardPosts posts={posts} setPosts={setPosts} />}
        />
      </SentryRoutes>
    </Layout>
  );
}
